module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-14.be79d8a5.png";